export default __webpack_public_path__ + "static/media/nodemon.322f63ab.svg";